module.exports = __webpack_public_path__ + "static/c_unchain-ba231be04bc5fefa51475c90d646bdad.png";